import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid } from "react-bootstrap";

import dataContent from '../data/content.json';

import * as chooserActions from '../actions/actionsChooser';

import ChooserItem from '../components/chooser/ChooserItem'

class ChooserContainer extends Component {
  render() {
    return (
      <Grid className="main-container chooser">
        <div className="flex-row">
          {dataContent.chooser.items.map((item, i) => <ChooserItem key={i} content={item} />)}
        </div>
      </Grid>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    chooser: state.chooser
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(chooserActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChooserContainer);



// WEBPACK FOOTER //
// ./src/containers/ChooserContainer.js